import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import useSurveyInfo from "./useSurveyInfo";

export default function useQuestionTab(props) {
  const {
    fetchDetailSurveyModel,
    deleteSectionModel,
    deleteQuestionModel,
    mergeSectionModel,
    moveSectionModel,
    editSurveyModel,
  } = surveyModel();

  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
    openWarningModal,
  } = useValidationModal();

  const { resolveDate, resolveTime } = useFlatPickr();

  const vm = getCurrentInstance().proxy;

  const formData = reactive({
    surveyGroupId: 0,
    titleName: "",
    surveyName: "",
    surveyDesc: "",
    bannerImage: { file: null, url: null },
    displayImage: { file: null, url: null },
    status: false,
    validFrom: { date: null, time: null },
    validThrough: { date: null, time: null },
    isUploadImageQA: false,
    isHaspermission: false,
    permissionType: 1,
    permissionData: {},
    privilegeData: {},
    scoreData: {},
    sectionMove: [],
    isOther: false,
    isEdit: true,
  });

  let formQuestion = reactive({
    payload: [
      // {
      //   seqSection: 0,
      //   sectionId: 1,
      //   sectionName: "test1",
      //   sectionDesc: "test desc",
      //   secctionMove: 1,
      //   question: [
      //     {
      //       seqQuestion: 0,
      //       questionId: 1,
      //       questionName: "Question",
      //       questionDesc: "Description",
      //       image: { file: null, url: null },
      //       type: 1,
      //       format: 1,
      //       isRequired: false,
      //       isShowImage: false,
      //       linkToType: 5,
      //       nextstepOptionOfOption: []
      //       dataChoice: [
      //         {
      //           seqChoice: 0,
      //           choiceId: null,
      //           choiceName: "choice",
      //           imageChoice: { file: null, url: null },
      //           other: "",
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   seqSection: 1,
      //   sectionId: 2,
      //   sectionName: "test2",
      //   sectionDesc: "test desc",
      //   secctionMove: 1,
      //   question: [
      //     {
      //       seqQuestion: 0,
      //       questionId: 2,
      //       questionName: "Question",
      //       questionDesc: "Description",
      //       image: { file: null, url: null },
      //       type: 2,
      //       format: 1,
      //       isRequired: false,
      //       isShowImage: false,
      //       linkToType: 2,
      //       IsDeleteImage: false
      //       dataChoice: [
      //         {
      //           seqChoice: 0,
      //           choiceId: null,
      //           choiceName: "choice",
      //           imageChoice: { file: null, url: null },
      //           other: "",
      //           IsDeleteImage: false
      //         },
      //       ],
      //     },
      //     {
      //       seqQuestion: 0,
      //       questionId: 3,
      //       questionName: "Question",
      //       questionDesc: "Description",
      //       image: { file: null, url: null },
      //       type: 3,
      //       format: 1,
      //       isRequired: false,
      //       isShowImage: false,
      //       linkToType: 3,
      //       dataChoice: [
      //         {
      //           seqChoice: 0,
      //           choiceId: null,
      //           choiceName: "choice",
      //           imageChoice: { file: null, url: null },
      //           other: "",
      //         },
      //       ],
      //     },
      //   ],
      // },
    ],
  });

  const optionQuestion = reactive({
    typeChoiceOption: [
      { label: "Single Choice", value: 1, icon: "SingleChoiceSvg" },
      { label: "Multiple Choice", value: 2, icon: "MultipleChoiceSvg" },
      { label: "Text Area", value: 3, icon: "TextAreaSvg" },
      { label: "Date", value: 4, icon: "DateSvg" },
      { label: "Dropdown", value: 5, icon: "DropdownSvg" },
    ],
    formatChoiceOption: [
      { label: "Text", value: 1 },
      { label: "Image", value: 2 },
      { label: "Text & Image", value: 3 },
    ],
    nextStepOption: [],
  });

  const onAddChoice = (question) => {
    question.dataChoice.push({
      choiceId: null,
      choiceName: "",
      imageChoice: { file: null, url: null },
      other: false,
      nextstep_type: 0,
      nextstep_option: [],
    });

    //จัดให้ other อยู่ index สุดท้ายเสมอ
    let indexOther = question.dataChoice.findIndex((e) => {
      return e.other == true;
    });

    if (indexOther !== -1) {
      //ลบ object ที่มี other = true เก็บไว้ใน OtherData แล้วก็ push กลับเข้าไปใหม่เพื่อให้อยู่ index สุดท้าย
      let otherData = question.dataChoice.splice(indexOther, 1)[0];
      question.dataChoice.push(otherData);
    }
  };

  const onAddOther = (question) => {
    question.dataChoice.push({
      choiceId: null,
      choiceName: "",
      imageChoice: { file: null, url: null },
      other: true,
      nextstep_type: 0,
      nextstep_option: [],
    });

    let indexOther = question.dataChoice.findIndex((e) => {
      return e.other == true;
    });

    if (indexOther != -1) {
      question.isOther = true;
    }
  };

  const onRemoveChoice = (index, choice, question) => {
    if (question.isOther) {
      choice.splice(index, 1);
    } else {
      question.isOther = false;
      choice.splice(index, 1);
    }
  };

  const onUploadImage = (image, formData) => {
    formData.IsDeleteImage = false;

    formData.image.file = image.file;
    formData.image.url = image.url;

    if (!formData.image.file && !formData.image.url) {
      formData.IsDeleteImage = true;
    }
  };

  const onUploadImageChoice = (image, formData) => {
    formData.IsDeleteImage = false;

    formData.imageChoice.file = image.file;
    formData.imageChoice.url = image.url;

    if (!formData.imageChoice.file && !formData.imageChoice.url) {
      formData.IsDeleteImage = true;
    }
  };

  const onDuplicateSection = (sectionObj, idx) => {
    let dataDuplicateSection = {
      sectionId: 0,
      sectionName: sectionObj.sectionName,
      sectionDesc: sectionObj.sectionDesc,
      nextstepType: sectionObj.nextstepType,
      nextstepOption: sectionObj.nextstepOption,
      nextSectionId: sectionObj.nextSectionId,
      question:
        sectionObj.question.length > 0
          ? sectionObj.question.map((questionObj) => ({
              // seqQuestion: idx + 1,
              questionId: questionObj.questionId,
              questionName: questionObj.questionName,
              questionDesc: questionObj.questionDesc,
              image: {
                file: questionObj.image.file,
                url: questionObj.image.url,
              },
              type: questionObj.type,
              format: questionObj.format,
              isRequired: questionObj.isRequired,
              linkToType: questionObj.linkToType,
              nextstepOption: questionObj.nextstepOption,
              nextSectionId: questionObj.nextSectionId,
              nextQuestionId: questionObj.nextQuestionId,
              nextstepOptionOfOption: [],
              dataChoice:
                questionObj.dataChoice.length > 0
                  ? questionObj.dataChoice.map((choiceObj, idx) => ({
                      choiceId: choiceObj.choiceId,
                      choiceName: choiceObj.choiceName,
                      imageChoice: {
                        file: choiceObj.imageChoice.file,
                        url: choiceObj.imageChoice.url,
                      },
                      other: choiceObj.other,
                      nextstep_type: choiceObj.nextstep_type,
                      nextSectionId: choiceObj.nextSectionId,
                      nextQuestionId: choiceObj.nextQuestionId,
                    }))
                  : [],
            }))
          : "",
    };

    formQuestion.payload.splice(idx + 1, 0, dataDuplicateSection);

    vm.$emit("EditQuestion");
  };

  const onDuplicateQuestion = (questionObj, sectionObj) => {
    let index = sectionObj.question.indexOf(questionObj);

    let dataDuplicateQuestion = {
      // seqQuestion: 1,
      questionId: 0,
      questionName: questionObj.questionName,
      questionDesc: questionObj.questionDesc,
      image: { url: questionObj.image.url },
      type: questionObj.type,
      format: questionObj.format,
      isRequired: questionObj.isRequired,
      linkToType: questionObj.linkToType,
      nextstepOption: questionObj.nextstepOption,
      nextSectionId: questionObj.nextSectionId,
      nextQuestionId: questionObj.nextQuestionId,
      nextstepOptionOfOption: [],

      dataChoice:
        questionObj.dataChoice.length > 0
          ? questionObj.dataChoice.map((o, idx) => ({
              choiceId: null,
              choiceName: o.choiceName,
              imageChoice: { url: o.imageChoice.url },
              other: o.other,
              nextstep_type: o.nextstep_type,
              nextSectionId: o.nextSectionId,
              nextQuestionId: o.nextQuestionId,
            }))
          : [],
    };

    sectionObj.question.splice(index + 1, 0, dataDuplicateQuestion);

    vm.$emit("EditQuestion");
  };

  const onAddSection = (item) => {
    let index = formQuestion.payload.indexOf(item);

    const lastIndex = formQuestion.payload.length - 1;

    let sectionQuestionData = {
      seqSection: 0,
      sectionId: 0,
      sectionName: "",
      sectionDesc: "",
      nextstepType: lastIndex == index ? 6 : 1,
      nextstepOption: [],
      nextSectionId: null,
      question: [
        {
          seqQuestion: 0,
          questionId: 0,
          questionName: "",
          questionDesc: "",
          image: { file: null, url: null },
          type: 1,
          format: 1,
          isRequired: false,
          isShowImage: false,
          linkToType: 2,
          nextstepOption: [],
          nextSectionId: null,
          nextQuestionId: null,
          nextstepOptionOfOption: [],
          dataChoice: [
            {
              seqChoice: 0,
              choiceId: null,
              choiceName: "",
              imageChoice: { file: null, url: null },
              other: "",
              nextstep_type: 0,
              nextSectionId: null,
              nextQuestionId: null,
            },
          ],
        },
      ],
    };

    formQuestion.payload.splice(index + 1, 0, sectionQuestionData);

    vm.$nextTick(() => {
      vm.$emit("EditQuestion");
    });
  };

  const onAddQuestion = (question) => {
    question.question.push({
      seqQuestion: 0,
      questionId: 0,
      questionName: "",
      questionDesc: "",
      image: { file: null, url: null },
      type: 1,
      format: 1,
      isRequired: false,
      isShowImage: false,
      linkToType: 2,
      nextstepOption: [],
      nextSectionId: null,
      nextQuestionId: null,
      nextstepOptionOfOption: [],
      dataChoice: [
        {
          seqChoice: 0,
          choiceId: null,
          choiceName: "",
          imageChoice: { file: null, url: null },
          other: false,
          nextstep_type: 0,
          nextSectionId: null,
          nextQuestionId: null,
        },
      ],
    });

    vm.$nextTick(() => {
      vm.$emit("EditQuestion");
    });
  };

  const onMergeSection = (sectionId, gotoSectionId) => {
    window.$loading(true);
    mergeSectionModel.payload.Survey_GroupId = formData.surveyGroupId;
    mergeSectionModel.payload.Curent_SectionId = sectionId;
    mergeSectionModel.payload.Goto_SectionId = gotoSectionId;

    store
      .dispatch("api/apiRequest", mergeSectionModel)
      .then((response) => {
        if (response.status == "success") {
          const responseSection = response.data.resp.section;

          formQuestion.payload.splice(0);
          responseSection.map((section) => {
            formQuestion.payload.push({
              seqSection: section.seq,
              sectionId: section.sectionid,
              sectionName: section.sec_name_htmleditor,
              sectionDesc: section.sec_desc_htmleditor,
              nextstepType: section.nextstep_type,
              nextstepOption: section.nextstep_option,
              nextSectionId: section.next_sectionid,
              question: [],
            });

            let formQuestionList = [];

            formQuestion.payload.map((section) => {
              formQuestionList = section.question;
            });

            if (section.question) {
              section.question.map((question) => {
                formQuestionList.push({
                  seqQuestion: question.seq,
                  questionId: question.questionid,
                  questionName: question.ques_name_htmleditor,
                  questionDesc: question.ques_desc_htmleditor,
                  image: { url: question.ques_image_url },
                  type: question.choice_mode,
                  format: question.input_type,
                  isRequired: question.isrequired,
                  linkToType: question.nextstep_type,
                  nextstepOption: question.nextstep_option,
                  nextSectionId: question.next_sectionid,
                  nextQuestionId: question.next_questionid,
                  dataChoice: [],
                  nextstepOptionOfOption: question.nextstep_option_of_option,
                });

                let formChoiceList = [];
                formQuestionList.map((question) => {
                  formChoiceList = question.dataChoice;
                });

                if (question.option) {
                  question.option.map((choice) => {
                    formChoiceList.push({
                      seqChoice: choice.seq,
                      choiceId: choice.optionid,
                      questionId: choice.questionid,
                      choiceName: choice.option,
                      imageChoice: { url: choice.option_image_url },
                      other: choice.isotheranswer,
                      nextstep_type: choice.nextstep_type,
                      nextSectionId: choice.next_sectionid,
                      nextQuestionId: choice.next_questionid,
                    });
                  });
                }
              });
            }
          });
          fetchDetailSurvey();
        }
      })
      .catch((error) => {
        openErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onUploadBanner = (image) => {
    formData.bannerImage.file = image.file;
    formData.bannerImage.url = image.url;
  };
  const onUploadDisplay = (image) => {
    formData.displayImage.file = image.file;
    formData.displayImage.url = image.url;
  };

  const resolveNextStepOption = (choice, question) => {
    let result = null;
    let payload = {
      label: null,
      value: 0,
      obj: {},
    };
    let index = null;
    if (choice.nextstep_type == 3 && choice.next_questionid) {
      index = question.nextstep_option_of_option.findIndex(
        (o) =>
          o.nextstep_type == 3 && o.next_questionid == choice.next_questionid
      );
      result = question.nextstep_option_of_option.find(
        (o) =>
          o.nextstep_type == 3 && o.next_questionid == choice.next_questionid
      );
    } else if (choice.nextstep_type == 4 && choice.next_sectionid) {
      index = question.nextstep_option_of_option.findIndex(
        (o) => o.nextstep_type == 4 && o.next_sectionid == choice.next_sectionid
      );
      result = question.nextstep_option_of_option.find(
        (o) => o.nextstep_type == 4 && o.next_sectionid == choice.next_sectionid
      );
    } else {
      index = question.nextstep_option_of_option.findIndex(
        (o) => o.nextstep_type == choice.nextstep_type
      );
      result = question.nextstep_option_of_option.find(
        (o) => o.nextstep_type == choice.nextstep_type
      );
    }

    if (result) {
      payload = {
        label: result.nextstep_desc,
        value: index,
        obj: { ...result },
      };
    }

    return payload;
  };

  const fetchDetailSurvey = () => {
    window.$loading(true);
    if (props?.surveyGroupId) {
      formData.surveyGroupId = props.surveyGroupId;
    }

    fetchDetailSurveyModel.payload.Survey_GroupId = formData.surveyGroupId;

    store
      .dispatch("api/apiRequest", fetchDetailSurveyModel)
      .then((response) => {
        initSurveyDetail(response);
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const initSurveyDetail = (response, isDelete = false) => {
    if (!response) return;

    const responseInfo = response.data.resp.infomation;
    const responseSection = response.data.resp.section;

    formData.surveyGroupId = responseInfo.survey_groupid;
    formData.titleName = responseInfo.title;
    formData.surveyName = responseInfo.survey_name_htmleditor;
    formData.surveyDesc = responseInfo.survey_desc_htmleditor;
    formData.bannerImage.url = responseInfo.cover_image_url;
    formData.displayImage.url = responseInfo.display_image_url;
    formData.status = responseInfo.status == true;
    formData.validFrom.date = resolveDate(responseInfo.valid_from);
    formData.validFrom.time = resolveTime(responseInfo.valid_from);
    formData.validThrough.date = resolveDate(responseInfo.valid_through);
    formData.validThrough.time = resolveTime(responseInfo.valid_through);
    formData.isEdit = responseInfo.isedit;

    formData.sectionMove = responseSection;
    let formQuestionData = [];
    if (isDelete == false) {
      responseSection.map((section) => {
        formQuestionData.push({
          seqSection: section.seq,
          sectionId: section.sectionid,
          sectionName: section.sec_name_htmleditor,
          sectionDesc: section.sec_desc_htmleditor,
          nextstepType:
            section.nextstep_type == 4
              ? section.next_sectionid
              : section.nextstep_type,
          nextstepOption: section.nextstep_option,
          nextSectionId: section.next_sectionid,

          question: [],
        });

        let formQuestionList = [];

        formQuestionData.map((section) => {
          formQuestionList = section.question;
        });

        if (section.question) {
          section.question.map((question) => {
            formQuestionList.push({
              seqQuestion: question.seq,
              questionId: question.questionid,
              questionName: question.ques_name_htmleditor,
              questionDesc: question.ques_desc_htmleditor,
              image: { url: question.ques_image_url },
              type: question.choice_mode,
              format: question.input_type,
              isRequired: question.isrequired,
              linkToType: question.nextstep_type,
              nextstepOption: question.nextstep_option,
              nextSectionId: question.next_sectionid,
              nextQuestionId: question.next_questionid,
              nextstepOptionOfOption: question.nextstep_option_of_option,
              dataChoice: [],
            });

            let formChoiceList = [];
            formQuestionList.map((question) => {
              formChoiceList = question.dataChoice;
            });

            if (question.option) {
              question.option.map((choice) => {
                formChoiceList.push({
                  seqChoice: choice.seq,
                  choiceId: choice.optionid,
                  questionId: choice.questionid,
                  choiceName: choice.option,
                  imageChoice: { url: choice.option_image_url },
                  other: choice.isotheranswer,
                  nextstep_type: resolveNextStepOption(choice, question),
                  nextSectionId: choice.next_sectionid,
                  nextQuestionId: choice.next_questionid,
                });
              });
            }
          });
        }
      });
    }

    formQuestion.payload = [...formQuestionData];

    vm.$emit("onSetTitleName", formData.titleName);
  };

  const deleteSection = (sectionId, index) => {
    openWarningModal(
      `<span class="text-red">Delete Section</span>`,
      `Are you sure want to delete Section ? <br> You will <span class="text-red">not be able to recover</span> list.`,
      () => {
        if (sectionId) {
          window.$loading(true);
          deleteSectionModel.payload.Survey_GroupId = formData.surveyGroupId;
          deleteSectionModel.payload.SectionId = sectionId;
          store
            .dispatch("api/apiRequest", deleteSectionModel)
            .then((response) => {
              if (response.status == "success") {
                let sectionIdx = null;

                sectionIdx = formQuestion.payload.findIndex(
                  (e) => e.sectionId == sectionId
                );

                if (sectionIdx != -1) {
                  formQuestion.payload.splice(sectionIdx, 1);
                }

                fetchDetailSurvey();
              }
            })
            .catch((error) => {
              openErrorModal(error);
            })
            .finally(() => {
              window.$loading(false);
            });
        } else {
          formQuestion.payload.splice(index, 1);
        }
      }
    );
  };

  const deleteQuestion = (questionId, sectionId, questionObj, index) => {
    openWarningModal(
      `<span class="text-red">Delete Question</span>`,
      `Are you sure want to delete Question ? <br> You will <span class="text-red">not be able to recover</span> list.`,
      () => {
        if (questionId && sectionId) {
          window.$loading(true);
          deleteQuestionModel.payload.Survey_GroupId = formData.surveyGroupId;
          deleteQuestionModel.payload.SectionId = sectionId;
          deleteQuestionModel.payload.QuestionId = questionId;
          store
            .dispatch("api/apiRequest", deleteQuestionModel)
            .then((response) => {
              if (response.status == "success") {
                formQuestion.payload.map((o) => {
                  let questionIdx = null;

                  questionIdx = o.question.findIndex(
                    (e) => e.questionId == questionId
                  );
                  if (questionIdx != -1) {
                    o.question.splice(questionIdx, 1);
                  }
                });

                fetchDetailSurvey();
              }
            })
            .catch((error) => {
              openErrorModal(error);
            })
            .finally(() => {
              window.$loading(false);
            });
        } else {
          formQuestion.payload.map((o) => {
            o.question.splice(index, 1);
          });
        }
      }
    );
  };

  const onSaveReoder = (sectionMoveObj) => {
    formQuestion.payload.splice(0);
    sectionMoveObj.map((section) => {
      formQuestion.payload.push({
        seqSection: section.seq,
        sectionId: section.sectionid,
        sectionName: section.sec_name_htmleditor,
        sectionDesc: section.sec_desc_htmleditor,
        nextstepType:
          section.nextstep_type == 4
            ? section.next_sectionid
            : section.nextstep_type,
        nextstepOption: section.nextstep_option,
        nextSectionId: section.next_sectionid,
        question: [],
      });
      let formQuestionList = [];
      formQuestion.payload.map((section) => {
        formQuestionList = section.question;
      });
      if (section.question) {
        section.question.map((question) => {
          formQuestionList.push({
            seqQuestion: question.seq,
            questionId: question.questionid,
            questionName: question.ques_name_htmleditor,
            questionDesc: question.ques_desc_htmleditor,
            image: { url: question.ques_image_url },
            type: question.choice_mode,
            format: question.input_type,
            isRequired: question.isrequired,
            linkToType: question.nextstep_type,
            nextstepOption: question.nextstep_option,
            nextSectionId: question.next_sectionid,
            nextQuestionId: question.next_questionid,
            dataChoice: [],
            nextstepOptionOfOption: question.nextstep_option_of_option,
          });
          let formChoiceList = [];
          formQuestionList.map((question) => {
            formChoiceList = question.dataChoice;
          });
          if (question.option) {
            question.option.map((choice) => {
              formChoiceList.push({
                seqChoice: choice.seq,
                choiceId: choice.optionid,
                questionId: choice.questionid,
                choiceName: choice.option,
                imageChoice: { url: choice.option_image_url },
                other: choice.isotheranswer,
                nextstep_type: choice.nextstep_type,
                nextSectionId: choice.next_sectionid,
                nextQuestionId: choice.next_questionid,
              });
            });
          }
        });
      }
    });
    vm.$emit("EditQuestion");
  };

  const nameNoHtml = computed(() =>
    formData.surveyName.replace(/<[^>]*>/g, "")
  );

  const validFormDisable = computed(() => {
    return (
      !nameNoHtml.value ||
      !formData.bannerImage.url ||
      !formData.displayImage.url ||
      !formData.validFrom.date ||
      !formData.validFrom.time ||
      !formData.validThrough.date ||
      !formData.validThrough.time
    );
  });

  const EditQuestion = (isNext, isMergeSection) => {
    vm.$emit("EditQuestion", isNext, isMergeSection);
  };

  watch(
    formData,

    () => {
      vm.$emit("onSetFormData", formData);
    },
    { deep: true }
  );

  watch(
    () => formQuestion.payload,
    () => {
      vm.$emit("onSetFormQuestion", formQuestion.payload);
    },
    { deep: true }
  );

  watch(
    () => props,
    () => {
      if (props?.isEdit && !props?.surveyAction.isMergeSection) {
        fetchDetailSurvey();
      }
    },
    { deep: true }
  );

  onBeforeMount(() => {
    if (router.currentRoute.query.surveyGroupId) {
      formData.surveyGroupId = parseInt(
        router.currentRoute.query.surveyGroupId
      );
    } else {
      formData.surveyGroupId = parseInt(router.currentRoute.params.ref);
    }

    vm.$emit("onSetFormQuestion", formQuestion.payload);
    if (formQuestion.payload.length == 1) {
      vm.$emit("EditQuestion");
    }
    if (formData.surveyGroupId) {
      fetchDetailSurvey();
    } else {
      return formQuestion.payload.push({
        seqSection: 0,
        sectionId: 0,
        sectionName: "Section Name",
        sectionDesc: "",
        nextstepType: 1,
        nextstepOption: [],
        nextSectionId: null,

        question: [
          {
            seqQuestion: 0,
            questionId: 1,
            questionName: "Question Name",
            questionDesc: "",
            image: { file: null, url: null },
            type: 1,
            format: 1,
            isRequired: false,
            isShowImage: false,
            linkToType: 2,
            nextstepOption: [],
            nextSectionId: null,
            nextQuestionId: null,
            nextstepOptionOfOption: [],
            dataChoice: [
              {
                seqChoice: 0,
                choiceId: null,
                choiceName: "choice",
                imageChoice: { file: null, url: null },
                other: false,
                nextstep_type: 0,
                nextSectionId: null,
                nextQuestionId: null,
              },
            ],
          },
        ],
      });
    }
  });

  return {
    formData,
    formQuestion,
    optionQuestion,
    onAddSection,
    onAddQuestion,
    onAddChoice,
    onAddOther,
    onRemoveChoice,
    onUploadImage,
    onUploadImageChoice,
    onDuplicateSection,
    onDuplicateQuestion,
    onMergeSection,
    onUploadBanner,
    onUploadDisplay,
    deleteQuestion,
    deleteSection,
    fetchDetailSurvey,
    initSurveyDetail,
    validFormDisable,
    EditQuestion,
    onSaveReoder,
  };
}
